import { RestrictedDateMetadata } from 'apiConnector/secondary-market/batch/base';
import { MonoDatePicker } from 'components/shared/DatePicker';
import { useCallback } from 'react';
import { SecondaryCellEditorProps } from 'routes/secondary-market-batch/grid/types';

export function RestrictedDateCellEditor({
  value,
  data,
  colDef: {
    field,
    context: { metadataId },
  },
  node,
  stopEditing,
}: SecondaryCellEditorProps<string>) {
  const metadata: RestrictedDateMetadata | undefined = metadataId
    ? (data?.metadata?.[metadataId] as RestrictedDateMetadata)
    : undefined;

  const onValueChanged = useCallback(
    (date: string | null) => {
      node.setDataValue(field!, date);
      stopEditing();
    },
    [field, node, stopEditing],
  );

  return (
    <MonoDatePicker
      id={data?.rowId}
      key={data?.rowId}
      value={value}
      blackoutDates={metadata?.blackoutDates}
      minDate={metadata?.minDate}
      allowWeekend={false}
      onChange={onValueChanged}
    />
  );
}
